// extracted by mini-css-extract-plugin
module.exports = {"estimatedTime":"style-module__estimatedTime___2gae4"};